export const listingsTransactionRemoveSubKey = listingData => {
  const { transaction_income: {
    additionalIncome
  }} = listingData;

  for(let add of additionalIncome){
    delete add.subKey;
  }
}
